import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircle, PlusSquare, ClipboardList, GitMerge, FolderOpen, X, MessageCircle } from 'lucide-react';
import { useOnboarding } from '../context/OnboardingContext';
import './HelpButton.css';

const WHATSAPP_SUPPORT = 'https://wa.me/96655349654?text=' + encodeURIComponent('مرحباً، أحتاج مساعدة في منصة مِسك');

const tours = [
  { id: 'offers',   label: 'إضافة عرض',         icon: <PlusSquare size={18} />,   route: '/offers'   },
  { id: 'requests', label: 'إضافة طلب',          icon: <ClipboardList size={18} />, route: '/requests' },
  { id: 'matching', label: 'المطابقة التلقائية', icon: <GitMerge size={18} />,     route: '/requests' },
  { id: 'catalog',  label: 'الكتالوج',           icon: <FolderOpen size={18} />,   route: '/catalog'  },
];

const HelpButton = () => {
  const { startTour, startOnboarding } = useOnboarding();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // Close popup when clicking outside
  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const handleTour = (tourId, route) => {
    setOpen(false);
    if (route && window.location.pathname !== route) {
      navigate(route);
      setTimeout(() => startTour(tourId), 400);
    } else {
      startTour(tourId);
    }
  };

  return (
    <div className="help-btn-container" ref={containerRef}>
      {open && (
        <div className="help-popup" role="menu" aria-label="قائمة الجولات التعليمية">
          <div className="help-popup-header">
            <span>جولات تعليمية</span>
            <button className="help-popup-close" onClick={() => setOpen(false)} aria-label="إغلاق">
              <X size={16} />
            </button>
          </div>
          {tours.map((tour) => (
            <button
              key={tour.id}
              className="help-popup-item"
              role="menuitem"
              onClick={() => handleTour(tour.id, tour.route)}
            >
              <span className="help-popup-item-icon">{tour.icon}</span>
              {tour.label}
            </button>
          ))}
          <div className="help-popup-divider" />
          <button
            className="help-popup-full-tour"
            role="menuitem"
            onClick={() => { setOpen(false); navigate('/dashboard'); setTimeout(() => startOnboarding(), 400); }}
          >
            ⚡ جولة تعريفية شاملة
          </button>
          <div className="help-popup-divider" />
          <a
            href={WHATSAPP_SUPPORT}
            target="_blank"
            rel="noopener noreferrer"
            className="help-popup-item help-popup-contact"
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            <span className="help-popup-item-icon"><MessageCircle size={18} /></span>
            تواصل معنا
          </a>
        </div>
      )}

      <button
        className={`help-fab ${open ? 'help-fab--active' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-label="مركز المساعدة"
        aria-expanded={open}
      >
        <HelpCircle size={24} />
      </button>
    </div>
  );
};

export default HelpButton;
